import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
}

const ReactionIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 14;
  const color = props.color || '#4b4b4b';
  return <Icon name={'reaction'} size={size} color={color} />;
};

export default React.memo(ReactionIcon);
